import type { ReactNode } from 'react';
import type { Series } from '@/api/types';
import { EntityAutocomplete } from './EntityAutocomplete';
import { searchSeries, createSeries } from '@/api/series';

export interface SeriesAutocompleteProps {
  value: Series | null;
  onChange: (value: Series | null) => void;
  label?: string;
  disabled?: boolean;
  allowCreate?: boolean;
  size?: 'small' | 'medium';
}

export function SeriesAutocomplete({
  value,
  onChange,
  label = 'Цикл',
  disabled = false,
  allowCreate = true,
  size = 'medium',
}: SeriesAutocompleteProps): ReactNode {
  return (
    <EntityAutocomplete
      // Приведение типов нужно из‑за обобщённого EntityAutocomplete
      value={value as Series | null}
      onChange={onChange as (value: unknown) => void}
      label={label}
      disabled={disabled}
      allowCreate={allowCreate}
      size={size}
      searchFunction={searchSeries}
      createFunction={createSeries}
    />
  );
}
